//@import dependencies
import React, { CSSProperties } from 'react'
import { useTranslation } from 'react-i18next'
//@end

//@import components
import PublicAppContainer from 'app_components/layouts/public'
import TextComponent from 'app_components/commons/TextComponent/TextComponent'
//@end

// @import hooks
// @end

// @INFO Import types
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './../icontecResourcesScreen.scss'
import { Link } from 'react-router-dom'
import { routingService } from 'app_services/routingService'

// @INFO Import assets
const articulos = require('app_assets/images/resources/landing/resources/articulos.png')
const blogs = require('app_assets/images/resources/landing/resources/blogs.png')
const capsulas = require('app_assets/images/resources/landing/resources/capsulas.png')
const moocs = require('app_assets/images/resources/landing/resources/moocs.png')
const podcast = require('app_assets/images/resources/landing/resources/podcast.png')
const webinar = require('app_assets/images/resources/landing/resources/webinar.png')
// @end

// @ADD Component types
interface IIcontecResourcesScreenLayoutProps {}

const IcontecResourcesScreenLayout: React.FC<IIcontecResourcesScreenLayoutProps> = (props) => {

  const { t } = useTranslation()

  const items = [
    // {
    //   title: 'MOOCS',
    //   text: 'Los cursos en línea masivos y abiertos (MOOC) se manejan bajo la modalidad virtual y se caracterizan por ser gratuitos, cortos y autogestionados, cuyos contenidos están orientados a profundizar en temáticas de actualidad, donde nuestros expertos presentan los enfoques y complementan esta información con el desarrollo de talleres prácticos que permiten apropiar conceptos y facilitar su aplicación en contextos organizacionales.  Si el participante puede optar por el pago y obtención de la certificación del curso.',
    //   image: moocs,
    //   url: '/moocs'
    // },
    {
      title: 'Webinar',
      text: 'Los webinar que desarrollamos en Icontec, son espacios académicos en vivo que se transmiten a través de la web y desarrollados por expertos frente a temáticas actuales y específicas basadas en herramientas y/o buenas prácticas que faciliten los procesos de implementación en las organizaciones. Para fortalecer la interacción con el expositor y aclarar los contenidos presentados, se destina un breve espacio para responder preguntas de los participantes, donde se seleccionan las preguntas más relevantes y se resuelven por parte del expositor al finalizar la presentación.',
      image: webinar,
      url: '/webinars'
    },
    {
      title: 'Cápsulas',
      text: 'Las cápsulas de conocimiento son espacios académicos pregrabados presentados por expertos de Icontec, que tienen el sentido de proveer información práctica, realista y contextualizada en diferentes temáticas asociadas a sectores de la economía, integrando en su  desarrollo ejemplos o buenas prácticas con enfoque concreto de fácil recordación que da orientación al  participante sobre la temática en particular',
      image: capsulas,
      url: '/capsulas'
    },
    {
      title: "Blog's",
      text: 'El blog en Icontec es un sitio web que destinamos para el aprendizaje colaborativo, en el que publicamos contenidos especializados cortos de actualidad y damos la oportunidad para que nuestros lectores se expresen sobre ellos y de esta manera podamos generar un valioso espacio de construcción de conocimiento.',
      image: blogs,
      url: '/blogs'
    },
    {
      title: 'Artículos',
      text: 'Los artículos web son documentos digitales escritos por un experto de ICONTEC sobre  temáticas que apoyan la  sostenibilidad y el mejoramiento de las organizaciones y  los  sistemas de gestión, en  la  que  puede presentarse información de manera  muy  práctica  frente a la descripción y enfoques de referentes normativos, herramientas para  facilitar su  implementación  o  buenas prácticas manifestadas desde la  experiencia que  tienen los  autores de los artículos, de forma que los lectores puedan  tener orientaciones claras para abordar estos contenidos en  sus  entornos  organizacionales.',
      image: articulos,
      url: '/articulos'
    },
    {
      title: 'Podcast',
      text: 'Los Podcast son contenidos en formato de audio, grabados por expertos de Icontec con la experiencia en temáticas específicas, enfocados a compartir ideas, conceptos y enfoques de gestión ayudando a nuestros oyentes a interiorizarlas y reflexionar en su aplicación en sus contextos laborales y organizacionales.  Estos contenidos pueden ser presentados en grabaciones individuales donde el experto expone resuelve preguntas clave alrededor de una temática específica. También se puede desarrollar por el medio de entrevistas o panel de discusión.',
      image: podcast,
      url: '/podcasts'
    },
  ]

  return(
    <PublicAppContainer>
      <div className='icontec_resources-layout'>
        <h1>Recursos educativos</h1>
        <div className="icontec_resources--cards-container">
          {items.map((_item) => (
            <Link to={routingService.getPublicPath(_item?.url)} key={_item.title}>
              <ItemExplication
                image={_item.image}
                text={_item.text}
                title={_item.title}
              />
            </Link>
          ))}
        </div>
      </div>
    </PublicAppContainer>
  )
}

// ==================================================
// @INFO Item de explicación
// ==================================================
interface IItemExplicationProps {
  image: any
  title: string
  text: string
  className?: string
  style?: CSSProperties
  id?: string
}

const ItemExplication: React.FC<IItemExplicationProps> = (props) => {
  return(
    <div
      className={`item_explication-layout ${props.className ? props.className : ''}`}
      style={props.style}
      id={props.id}
    >
      <img src={props.image} alt="" />
      <div className="container-shadow"></div>
      <div className="container-text-item">
        <TextComponent
          type='subtitle'
          style={{ fontWeight: 700, color: 'white' }}
        >
          {props.title}
        </TextComponent>
      </div>
    </div>
  );
}


export default IcontecResourcesScreenLayout
